export default __webpack_public_path__ + "static/media/icon-info.4f48b96a.svg";